import React, {useContext} from "react";
import './drawerMenu.scss';
import {animated} from "@react-spring/web";
import DrawerMenuContext from "../../../services/hooks/DrawerMenuContext";
import headerMenu from "../../../config/HeaderMenu";
import SvgClose from "../../../components/ui/icons/SvgClose";
import DrawerMenuItem from "./DrawerMenuItem";

interface Props {
    isHomePage?: boolean,
}

const DrawerMenu = ({
    isHomePage = false,
                    }: Props) => {
    const {
        openMenu,
        closeMenu,
        animationStyle,
        isOpen,
    } = useContext(DrawerMenuContext);

    return (
        <>
            <div className='drawerMenuIcon'>
                {
                    isOpen ? (
                        <div
                            className="closeIconContainer"
                            role="button"
                            onClick={closeMenu}
                        >
                            <SvgClose />
                        </div>
                    ) : (
                        <div
                            className="mobileMenu"
                            role="button"
                            onClick={openMenu}
                        />
                    )
                }
            </div>
            <animated.div
                className='drawerMenu'
                style={animationStyle}
            >
                <div className="menuContent">
                    <div className="mobileMenuList">
                        {
                            Object
                                .keys(headerMenu)
                                .filter(key => {
                                    if(isHomePage) return true; //home page: display MySpace
                                    return key !== 'mySpace'; //otherwise: no
                                })
                                ?.map(menuItem => <DrawerMenuItem menuItem={menuItem} key={menuItem} />)
                        }
                    </div>
                </div>
            </animated.div>
        </>
    );
};

export default DrawerMenu;